import React, { memo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import DialogConfirm from '../molecules/DialogConfirm';
import { status_code_list } from '../Const';
import Popup from '../molecules/Popup';

interface Props {
  has_debtor: boolean; // 連帯債務者の有無
  handleClickDecline: () => Promise<any>; // 「辞退する」のアクション
  handleClickResendMail: () => void; // 「連帯債務者等の方へ確認依頼メールを再送する」のアクション
  handleClickChangeDetails: () => Promise<any>; // 「申込内容を変更する」のアクション
  reception_cd: string;
  reception_id: number;
  status_code: number;
  setIsLoading: (flag: boolean) => void;
}

// 借入申込確認画面（ステータス2400,2500,2600,2700）
const FooterBorrowingApplicationConfirmation: React.FC<Props> = ({
  has_debtor,
  handleClickDecline,
  handleClickResendMail,
  handleClickChangeDetails,
  reception_cd,
  reception_id,
  status_code,
  setIsLoading,
}) => {
  const [modal_decline_open, setModalDeclineOpen] = useState(false);
  const history = useHistory();
  const [modal_change_details, setModalChangeDetails] = useState(false);

  const outputButton = () => {
    // 借入申込登録後
    // 「辞退する」ボタンを表示する
    // 「連帯債務者等の方への確認依頼メールを再送する」ボタンを表示する
    return (
      <Row className="my-5 flex-lg-row flex-md-reverse flex-sm-column-reverse flex-column-reverse">
        {jsxElementDecline()}
        {jsxElementResendMail()}
        {jsxElementChangeDetails()}
      </Row>
    );
  };

  // jsxElement「辞退する」
  const jsxElementDecline = () => {
    const handleClickOpenDecline = () => {
      setModalDeclineOpen(true);
    };

    // ステータス2700では辞退するボタンを非表示にする
    if (status_code === status_code_list.borrowing_application_withdrawal_wait) {
      return <Col xs={12} sm={6} md={6} lg={6} xl={6} className="row-left-button-danger"></Col>;
    }

    return (
      <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-left-button-danger">
        <div className="text-left sp-button-center">
          <a className="btn btn-xl btn-danger" onClick={handleClickOpenDecline}>
            辞退する
          </a>
        </div>
      </Col>
    );
  };
  // jsxElement「連帯債務者等の方へ確認依頼メールを再送する」
  const jsxElementResendMail = () => {
    //連帯債務者等が0人 又は ステータス2500の場合はボタンを非表示
    if (!has_debtor || status_code === status_code_list.borrowing_application_disagreement) {
      return <></>;
    }

    return (
      <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-no-arrow">
        <div className="text-right sp-button-center">
          <a className="btn btn-xl btn-main-color" onClick={handleClickResendMail}>
            連帯債務者等の方へ
            <br className="d-lg-none" />
            確認依頼メールを再送する
          </a>
        </div>
      </Col>
    );
  };

  // jsxElement「申込内容を変更する」
  const jsxElementChangeDetails = () => {
    const handleClickChangeDetails = () => {
      setModalChangeDetails(true);
    };
    //ステータス2500の場合のみボタンを表示
    return (
      <>
        {status_code === status_code_list.borrowing_application_disagreement ? (
          <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-small">
            <div className="text-right sp-button-center">
              <a className="btn btn-xl btn-main-color" onClick={handleClickChangeDetails}>
                申込内容を変更する
              </a>
            </div>
          </Col>
        ) : (
          <></>
        )}
      </>
    );
  };

  return (
    <>
      {outputButton()}
      <Popup
        title="借入申込の辞退確認"
        text="申込の辞退となりますが、よろしいですか？"
        first_button={{
          label: '辞退する',
          variant: 'danger',
          handleClick: () => {
            // 辞退するのAPI処理（CommonAPIをキックする）
            setModalDeclineOpen(false);
            handleClickDecline().then(res => {
              if (res) {
                history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/declined`);
              }
            });
          },
        }}
        second_button={{
          label: '戻る',
          variant: 'outline-success',
          handleClick: () => setModalDeclineOpen(false),
        }}
        toggleClose={() => setModalDeclineOpen(false)}
        toggleShow={modal_decline_open}
      />

      <Popup
        title="申込内容の変更"
        text="申込内容を変更できる状態に戻します。よろしいですか？"
        first_button={{
          label: '申込内容を変更する',
          variant: 'success',
          handleClick: () => {
            setModalChangeDetails(false);
            // 「申込内容を変更する」の処理（CommonAPIをキックする）
            handleClickChangeDetails();
          },
        }}
        second_button={{
          label: '戻る',
          variant: 'outline-success',
          handleClick: () => setModalChangeDetails(false),
        }}
        toggleClose={() => setModalChangeDetails(false)}
        toggleShow={modal_change_details}
      />
    </>
  );
};

export default memo(FooterBorrowingApplicationConfirmation);
